import { render, staticRenderFns } from "./Statuserweiterung.vue?vue&type=template&id=c76d8be2&"
import script from "./Statuserweiterung.vue?vue&type=script&lang=js&"
export * from "./Statuserweiterung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports